import { useEffect, useState } from 'react';
import styled from 'styled-components';
import NotificationToast from '../NotificationToast';
import { ContainerWrapper, Container } from '../Container';
import Section from '../Section';
import AddUserForm from './addUserForm';
import AddLocationForm from './addLocationForm';
import AddUserLocationForm from './addUserLocationForm';
import PublishProject from './publishProject';
import { addUser, addLocation, getUsers, getLocations, addUserLocation } from '../../services/userService';
import { publishOngeoserver, calculatePrediction } from '../../services/adminServices';
import { restartProject } from '../../services/projectService';
import CalculatePrediction from './calculatePredictions';
import ExportPilotsLocations from './exportPilotsLocations';
import ProjectRestart from './projectRestart';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 24px;
  row-gap: 48px;

  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (min-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

`;

// TODO
// - mobile view
// - handle loading/error
function AdminPage() {
  const [actionResult, setActionResult] = useState(null);
  const [userValues, setUserValues] = useState([]);
  const [locationValues, setLocationValues] = useState([]);

  useEffect(() => {
    getUsers().then(data => {
      setUserValues(data.map(u => ({ label: `${u.email}`, value: u.id })));
    });
    getLocations().then(data => {
      setLocationValues(data.map(l => ({ label: `${l.name}`, value: l.id })));
    });
  }, [])

  const submitAddUserForm = (values, form) => {

    addUser({
      firstname: values.firstname,
      surname: values.surname,
      country: values.country,
      email: values.email,
    })
    .then(() => {
      form.restart();
      setActionResult({
        kind: 'success',
        message: 'User has been successfully created.'
      });
      getUsers().then(data => {
        setUserValues(data.map(u => ({ label: `${u.email}`, value: u.id })));
      })
    })
    .catch(() => {
      setActionResult({
        kind: 'error',
        message: 'An error has occurred while creating new user. Try it once again or create a ticket.'
      });
    });
  }

  const submitAddLocationForm = (values, form) => {

    addLocation({
      name: values.name,
      description: values.description,
      type: values.type.value,
      country: values.country,
      srid: values.srid.value.toString()
    })
    .then(() => {
      form.restart();
      setActionResult({
        kind: 'success',
        message: 'Location has been successfully created.'
      });
      getLocations().then(data => {
        setLocationValues(data.map(l => ({ label: `${l.name}`, value: l.id })));
      })
    })
    .catch(() => {
      setActionResult({
        kind: 'error',
        message: 'An error has occurred while creating new location. Try it once again or create a ticket.'
      });
    });
  }

  const submitAddUserLocationForm = (values, form) => {
    addUserLocation({
      location: values.location.value,
      pilot: values.user.value
    })
    .then(() => {
      form.restart();
      setActionResult({
          kind: 'success',
          message: 'Location has been successfully assigned.'
        });
      }
    )
    .catch(() => {
      setActionResult({
        kind: 'error',
        message: 'An error has occurred while assigning location. Try it once again or create a ticket.'
      });
    });
  }

  // TODO
  // Test Method
  const submitPublishProjectForm = (values, form) => {

    publishOngeoserver({
      areaId: values.projectID,
      workspace: values.type.value,
      epsg: values.srid.value.toString(),
      cameraType: values.cameraType.value
    }).then(() => {
      form.restart();
      setActionResult({
        kind: 'success',
        message: 'Project has been published.'
      });
    })
    .catch(() => {
      setActionResult({
        kind: 'error',
        message: 'Error during project publish.'
      });
    });
  }

  // TODO
  // Test Method
  const submitCalculatePrediction = (values, form) => {
    console.log(values)
    calculatePrediction(
      values.projectID
    ).then(() => {
      form.restart();
      setActionResult({
        kind: 'success',
        message: 'Prediction calcualtion started.'
      });
    })
    .catch(() => {
      setActionResult({
        kind: 'error',
        message: 'Error during starting prediction calculation.'
      });
    });
  }

  const submitProjectRestart = (values, form) => {
    restartProject(values.projectID)
      .then(() => {
        form.restart();
        setActionResult({
          kind: 'success',
          message: 'Project has been restarted.'
        });
      })
      .catch(() => {
        setActionResult({
          kind: 'error',
          message: 'Error during project restart.'
        });
      });
  }

  return (
    <ContainerWrapper>
      <Container>
        <NotificationToast
          toastId="adminArea"
          kind={actionResult?.kind}
          message={actionResult?.message}
          onClose={() => setActionResult(null)}
        />
        <Section title="Admin Dashboard" isCollapsible={false}>
          <Grid>
            <AddUserForm
              handleFormSubmit={submitAddUserForm} />
            <AddLocationForm
              handleFormSubmit={submitAddLocationForm} />
            <AddUserLocationForm
              locationValues={locationValues}
              userValues={userValues}
              handleFormSubmit={submitAddUserLocationForm} />
            <PublishProject
              handleFormSubmit={submitPublishProjectForm}
            />
            <ProjectRestart
              handleFormSubmit={submitProjectRestart} />
            <CalculatePrediction
              handleFormSubmit={submitCalculatePrediction}
            />
            <ExportPilotsLocations
              users={userValues}
              locationValues={locationValues}
            />
          </Grid>
        </Section>
      </Container>
    </ContainerWrapper>
  );
}

export default AdminPage;